import { apiClient } from '@/shared/api';

import type {
  ContentBlock,
  ContentPage,
  ContentPageType,
  ContentStatus,
  CreatePageRequest,
  PageSummary,
  ReplaceBlocksRequest,
  UpdatePageRequest,
} from '../model/types';

const BASE = '/api/v1/merchant-portal/content/pages';

export interface ContentPagesFilters {
  type?: ContentPageType;
  status?: ContentStatus;
  locale?: string;
}

export const listPages = async (filters: ContentPagesFilters = {}): Promise<PageSummary[]> => {
  const response = await apiClient.get<PageSummary[]>(BASE, { params: filters });
  return response.data;
};

export const createPage = async (body: CreatePageRequest): Promise<ContentPage> =>
  (await apiClient.post<ContentPage>(BASE, body)).data;

export const getPage = async (slug: string, locale?: string): Promise<ContentPage> =>
  (await apiClient.get<ContentPage>(`${BASE}/${slug}`, { params: locale ? { locale } : undefined }))
    .data;

export const updatePage = async (
  slug: string,
  body: UpdatePageRequest,
  locale?: string,
): Promise<ContentPage> =>
  (
    await apiClient.put<ContentPage>(
      `${BASE}/${slug}`,
      body,
      locale ? { params: { locale } } : undefined,
    )
  ).data;

export const deletePage = async (slug: string, locale?: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${slug}`, { params: locale ? { locale } : undefined });
};

export const publishPage = async (slug: string, locale?: string): Promise<ContentPage> =>
  (
    await apiClient.post<ContentPage>(
      `${BASE}/${slug}/publish`,
      undefined,
      locale ? { params: { locale } } : undefined,
    )
  ).data;

export const unpublishPage = async (slug: string, locale?: string): Promise<ContentPage> =>
  (
    await apiClient.post<ContentPage>(
      `${BASE}/${slug}/unpublish`,
      undefined,
      locale ? { params: { locale } } : undefined,
    )
  ).data;

export const listBlocks = async (slug: string, locale?: string): Promise<ContentBlock[]> =>
  (
    await apiClient.get<ContentBlock[]>(`${BASE}/${slug}/blocks`, {
      params: locale ? { locale } : undefined,
    })
  ).data;

export const replaceBlocks = async (
  slug: string,
  body: ReplaceBlocksRequest,
  locale?: string,
): Promise<ContentBlock[]> =>
  (
    await apiClient.put<ContentBlock[]>(
      `${BASE}/${slug}/blocks`,
      body,
      locale ? { params: { locale } } : undefined,
    )
  ).data;

